import React, { useEffect, useRef } from 'react';
import cytoscape from 'cytoscape';

const GraphVisualization = ({ graphData }) => {
    const containerRef = useRef(null);
    const cyRef = useRef(null);

    useEffect(() => {
        if (!graphData || !containerRef.current) return;

        // Clear existing graph
        if (cyRef.current) {
            cyRef.current.destroy();
        }

        // Prepare elements for Cytoscape
        const elements = [];

        // Add nodes
        (graphData.nodes || []).forEach(node => {
            elements.push({
                data: {
                    id: node.id,
                    label: node.label || node.id,
                    type: node.node_type || node.type || 'default',
                    fullAddress: node.id
                }
            });
        });

        // Add edges
        (graphData.edges || []).forEach(edge => {
            elements.push({
                data: {
                    id: `${edge.source}-${edge.target}`,
                    source: edge.source,
                    target: edge.target,
                    label: edge.label || ''
                }
            });
        });

        // Initialize Cytoscape
        const cy = cytoscape({
            container: containerRef.current,
            elements,
            style: [
                {
                    selector: 'node[type = "wallet"]',
                    style: {
                        'background-color': '#ffc107',
                        'label': 'data(label)',
                        'font-size': 10,
                        'color': '#fff',
                        'text-valign': 'center',
                        'text-halign': 'center',
                        'width': 60,
                        'height': 60,
                        'border-width': 2,
                        'border-color': '#ff9800'
                    }
                },
                {
                    selector: 'node[type = "token_contract"], node[type = "token"]',
                    style: {
                        'shape': 'roundrectangle',
                        'background-color': '#0d6efd',
                        'label': 'data(label)',
                        'font-size': 10,
                        'color': '#fff',
                        'text-valign': 'center',
                        'text-halign': 'center',
                        'width': 60,
                        'height': 60,
                        'border-width': 2,
                        'border-color': '#0056b3'
                    }
                },
                {
                    selector: 'node[type = "cluster"]',
                    style: {
                        'shape': 'hexagon',
                        'background-color': '#dc3545',
                        'label': 'data(label)',
                        'font-size': 11,
                        'font-weight': 'bold',
                        'color': '#fff',
                        'text-valign': 'center',
                        'text-halign': 'center',
                        'width': 80,
                        'height': 80,
                        'border-width': 3,
                        'border-color': '#b02a37'
                    }
                },
                {
                    selector: 'node',
                    style: {
                        'background-color': '#6c757d',
                        'label': 'data(label)',
                        'font-size': 10,
                        'color': '#fff',
                        'text-valign': 'center',
                        'text-halign': 'center',
                        'width': 50,
                        'height': 50
                    }
                },
                {
                    selector: 'edge',
                    style: {
                        'line-color': '#6c757d',
                        'width': 3,
                        'target-arrow-shape': 'triangle',
                        'target-arrow-color': '#6c757d',
                        'curve-style': 'bezier',
                        'arrow-scale': 1.2,
                        'label': 'data(label)',
                        'font-size': 8,
                        'color': '#fff',
                        'text-background-color': '#333',
                        'text-background-opacity': 0.8,
                        'text-background-padding': 3
                    }
                }
            ],
            layout: {
                name: 'breadthfirst',
                directed: true,
                padding: 30,
                spacingFactor: 1.5
            }
        });

        // Add click handler for nodes
        cy.on('tap', 'node', function (evt) {
            const node = evt.target;
            const addr = node.data('id');
            const type = node.data('type');

            let typeLabel = 'Node';
            if (type === 'wallet') typeLabel = 'Wallet';
            else if (type === 'token' || type === 'token_contract') typeLabel = 'Contract';
            else if (type === 'cluster') typeLabel = 'Cluster';

            alert(`${typeLabel}:\n${addr}\n\nClick OK to copy to clipboard`);

            // Copy to clipboard
            navigator.clipboard.writeText(addr).catch(err => {
                console.error('Failed to copy address:', err);
            });
        });

        // Fit view
        setTimeout(() => {
            cy.fit(undefined, 30);
        }, 100);

        cyRef.current = cy;

        // Cleanup
        return () => {
            if (cyRef.current) {
                cyRef.current.destroy();
                cyRef.current = null;
            }
        };
    }, [graphData]);

    return (
        <div
            ref={containerRef}
            style={{
                height: '500px',
                border: '1px solid #2b2b2b',
                borderRadius: '10px',
                background: '#111'
            }}
        />
    );
};

export default GraphVisualization;

